import React from "react";
import { MapPin } from "lucide-react";

const areas = [
  "Cardiff", "Newport", "Caerphilly", "Barry", "Penarth",
  "Pontypridd", "Bridgend", "Merthyr Tydfil", "Swansea", "Vale of Glamorgan", "South Wales",
];

export const Areas = () => (
  <section id="areas" data-testid="areas-section" className="py-20 md:py-32 bg-[#0A192F] text-white relative overflow-hidden">
    <div className="absolute inset-0 opacity-[0.06]" aria-hidden style={{
      backgroundImage: "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)",
      backgroundSize: "28px 28px",
    }} />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <span className="text-xs tracking-[0.22em] uppercase font-bold text-[#7DA9FF]">Areas We Cover</span>
          <h2 className="mt-4 font-display font-semibold text-4xl sm:text-5xl tracking-tight">
            Serving Cardiff &amp; every corner of South Wales.
          </h2>
        </div>
        <p className="lg:col-span-5 text-lg text-slate-300 leading-relaxed">
          Local specialists with routes across the region — plus nationwide moves on request. If you&apos;re moving from or to South Wales, we&apos;ve got you covered.
        </p>
      </div>

      <div className="mt-12 flex flex-wrap gap-3">
        {areas.map((a) => (
          <span key={a} data-testid={`area-${a.toLowerCase().replace(/\s+/g, "-")}`}
                className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-5 py-2.5 text-sm font-medium hover:bg-white/10 transition-colors">
            <MapPin className="h-4 w-4 text-[#7DA9FF]" /> {a}
          </span>
        ))}
      </div>

      <p className="mt-10 text-sm text-slate-400">
        Nationwide moves also available on request. Message us on WhatsApp for a tailored quote.
      </p>
    </div>
  </section>
);
